import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Switch — Radix's, wrapped.
 *
 * A switch is for a setting that takes effect immediately; a checkbox is for something that is
 * submitted with a form. The difference matters to a screen reader, which announces this one as
 * "switch, on".
 *
 * The state is never carried by colour alone: the thumb moves, and the optional `stateLabel` spells
 * out On or Off next to it (WCAG 1.4.1).
 */
import * as RadixSwitch from '@radix-ui/react-switch';
import { useId } from 'react';
import { useUiText } from '@clavian/i18n/react';
import { cx } from '../lib/cx.js';
export function Switch({ label, id, stateLabel = false, className, 'aria-describedby': describedBy, ...rest }) {
    const t = useUiText();
    const generated = useId();
    const controlId = id ?? generated;
    return (_jsxs("div", { className: cx('clav-choice', className), children: [_jsx(RadixSwitch.Root, { ...rest, id: controlId, className: "clav-switch", "aria-describedby": describedBy, children: _jsx(RadixSwitch.Thumb, { className: "clav-switch__thumb" }) }), _jsxs("label", { className: "clav-choice__label", htmlFor: controlId, children: [label, stateLabel ? (_jsxs("span", { className: "clav-field__optional", children: [" \u00B7 ", rest.checked ? t('switch.on') : t('switch.off')] })) : null] })] }));
}
//# sourceMappingURL=switch.js.map